import store from './checkout/s';
import {checkout} from './api';
import React from 'react';
import {observable, action, makeObservable} from 'mobx';
import Confidence from './checkout/components/confidence';
import {getPhoneHREF, Portal} from './util';

declare var openz: any;
declare var __company_name: string;
declare var __domain_name: string;

interface IErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<any, IErrorBoundaryState> {
    @observable errorMsg: string;
    @observable errorInfo: string;

    constructor(props) {
        super(props);
        this.state = {hasError: false};
        this.clearError = this.clearError.bind(this);
        makeObservable(this);
    }

    static getDerivedStateFromError(error) {
        console.error(error);
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        try {
            this.errorMsg = error.toString();
        } catch {
            this.errorMsg = 'Error';
        }
        try {
            this.errorInfo = JSON.stringify(info);
        } catch {
            this.errorInfo = 'Error';
        }
        store.errorLog = error;
        store.errorLogInfo = error.toString();
        console.error(error);
        console.error(info);
        this.state = {hasError: true};
        checkout('error-log');
        this.forceUpdate();
    }

    @action
    clearError = () => {
        this.state = {hasError: false};
        console.log('cleaning error');
        store.initCheckout();
        store.uiCheckout.requireReset = true;
        store.moveStep(ICheckoutStep.cart);
        this.forceUpdate();
        window.location.href = '/cart';
    };

    render() {
        if (this.state.hasError && store && Portal) {
            return (
                <div style={{paddingTop: 24}}>
                    <div className="checkout">
                        <div className="checkout-v4-skin-header">
                            <div className="logo">
                                <a
                                    href="/"
                                    aria-label="Home"
                                >
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${Portal?.CDNDomain}/images/cached/general/logo_45.webp`}
                                        />
                                        <img
                                            className="resp"
                                            src={`https://${Portal?.CDNDomain}/images/cached/general/logo_45.png`}
                                            alt=""
                                            width={360}
                                            height={45}
                                            loading="lazy"
                                        />
                                    </picture>
                                </a>
                            </div>
                            <div>
                                <span className="chat-desktop hidden-xs hidden-sm">
                                    <a
                                        href={getPhoneHREF()}
                                        style={{color: '#595959'}}
                                    >
                                        {Portal?.CustomerServicePhone}
                                    </a>
                                    <span style={{paddingLeft: 12, paddingRight: 4}}>
                                        <span style={{paddingRight: 4, color: '#595959'}}>
                                            <i
                                                className="fas fa-comment-alt-dots"
                                                aria-hidden={true}
                                            />
                                        </span>
                                        <span
                                            style={{color: '#595959', cursor: 'pointer'}}
                                            onClick={() => {
                                                openz();
                                                return false;
                                            }}
                                            aria-label="chat"
                                            aria-haspopup="dialog"
                                            role="button"
                                            tabIndex={0}
                                        >
                                            Chat
                                        </span>
                                    </span>
                                </span>
                                <span>
                                    <span
                                        className="link pointer cart-icon"
                                        onClick={() => store.moveStep(ICheckoutStep.cart)}
                                        role="button"
                                        aria-label="Cart"
                                    >
                                        <span style={{paddingRight: 6}}>
                                            <i className="fas fa-shopping-cart" />
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <hr />A checkout error has occurred.
                        <ul>
                            <li>If you were in the process of placing an order, please click below to reset your cart.</li>
                            <li>Otherwise, please contact us at {Portal?.CustomerServicePhone} for any other issues.</li>
                        </ul>
                        <div style={{paddingLeft: '5%'}}>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg"
                                onClick={this.clearError}
                            >
                                Continue - Reset Cart
                            </button>
                        </div>
                        <div style={{paddingTop: 48}}>Error details:</div>
                        <div className="alert alert-danger">
                            <div>{this.errorMsg}</div>
                        </div>
                        <div
                            className="hidden-xs"
                            style={{marginTop: '15%'}}
                        />
                        <div className="row hidden-sm hidden-md hidden-lg hidden-xl">
                            <div
                                className="col-12"
                                style={{padding: '20px 0'}}
                            >
                                <div className="hr" />
                                <Confidence />
                                <div className="hr" />
                            </div>
                        </div>
                        <div className="row row-footer">
                            <div className="col-12 col-sm-9 col-footer col-footer-1">
                                <span>
                                    <a href={getPhoneHREF()}>{Portal?.CustomerServicePhone}</a>
                                </span>
                                <span>
                                    <span
                                        style={{cursor: 'pointer', fontSize: '12px'}}
                                        onClick={() => {
                                            openz();
                                            return false;
                                        }}
                                        role="button"
                                        aria-label="Chat"
                                        aria-haspopup="dialog"
                                        tabIndex={0}
                                    >
                                        <span style={{paddingRight: 4, color: '#999'}}>
                                            <i
                                                className="fas fa-comment-alt-dots"
                                                aria-hidden={true}
                                            />
                                        </span>{' '}
                                        Chat
                                    </span>
                                </span>
                                <span>
                                    <a href="/customer-service/return-policy.aspx">{Portal.PortalID < 3 ? '120' : '30'}-Day Return Policy</a>
                                </span>
                                <span>
                                    <a href="/customer-service/frequently-asked-questions-faq.aspx">FAQ</a>
                                </span>
                                <span>
                                    <a href="/customer-service.aspx">Customer Service</a>
                                </span>
                                <span style={{fontSize: '12px', cursor: 'default'}}>
                                    Secure Checkout{' '}
                                    <span style={{paddingLeft: 4}}>
                                        <i
                                            className="fas fa-lock"
                                            aria-hidden={true}
                                        ></i>
                                    </span>
                                </span>
                            </div>

                            <div
                                className="col-12 col-sm-3 col-footer text-right"
                                style={{fontSize: '12px'}}
                            >
                                <span>
                                    &copy; {__company_name} {new Date().getFullYear().toString()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            );

            // return <div>Error</div>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
